module.exports = __webpack_public_path__ + "static/media/formula_image.30655e9d.png";